import React, { useState } from "react";
import axios, { AxiosRequestHeaders } from "axios";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import ConfirmationModal from "../shared/ConfirmationModal";
import NewconfirmationModal from "../shared/NewconfirmationModal";
import AllFailureModal from "../shared/AllFailureModal";


const CityAdd = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [modalAction, setModalAction] = useState(null);
  const [formValues, setFormValues] = useState(null);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showFailureModal, setShowFailureModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [failureMessage, setFailureMessage] = useState("");
  const headers = {
    "x-access-token": localStorage.getItem("jwttoken") || "",
  };

  const validateForm = (values) => {
    const errors = {};
    if (!values.city_name.trim()) {
      errors.city_name = "City name is required";
    }
    if (!values.state_name) {
      errors.state_name = "State is required";
    }

    if (!values.pin_code.trim()) {
      errors.pin_code = "Pincode is required";
    } else if (!/^\d{6}$/.test(values.pin_code)) {
      errors.pin_code = "Pincode must be a 6-digit number";

      return errors;
    }};

    const callApiCityAdd = async (values) => {
      try {
        const url = `${process.env.REACT_APP_API_URL}cities/createcity`;
        const response = await axios.post(url, values, { headers });
        if (response.status === 201) {
          setSuccessMessage("City added successfully.");
          setShowSuccessModal(true);
          setTimeout(() => {
            navigate('/citylist');
          }, 3000);
        }
      } catch (error) {
        console.error("Error adding city:", error);
        if (error.response) {
          if (error.response.status === 409) {
            setFailureMessage("City already exists. Please try another name.");
          } else {
            setFailureMessage(error.response.data.error || "Failed to add city. Please try again.");
          }
        } else {
          setFailureMessage("Failed to add city. Please check your connection.");
        }
        setShowFailureModal(true);
      }
    };

    const handleSubmit = (values) => {
      setFormValues(values);
      setModalAction('Confirm');
      setShowModal(true);
    };

    const handleConfirm = async () => {
      if (modalAction === 'Confirm' && formValues) {
        try {
          await callApiCityAdd(formValues);
        } catch (error) {
          console.error("Error adding city:", error);
          setFailureMessage("Error adding city");
          setShowFailureModal(true);
        }
      }
      setShowModal(false);
    };

    const handleCancel = () => {
      setShowModal(false);
    };

    return (
      <Container className="mt-5">
        <Row className="justify-content-center">
          <Col md={8}>
            <Card className="shadow">
              <Card.Header className="bg-info text-white text-center">
                <h4>Add New City</h4>
              </Card.Header>
              <Card.Body>
                <Formik
                  initialValues={{ city_name: "", state_name: "", country: "India", pin_code: "" }}
                  validate={validateForm}
                  validateOnMount={true}
                  onSubmit={handleSubmit}
                >
                  {({ errors, touched }) => (
                    <Form>
                      <Row className="mb-3">
                        <Col md={12}>
                          <label htmlFor="city_name" className="form-label">
                            City Name:
                          </label>
                          <Field
                            name="city_name"
                            type="text"
                            className={`form-control ${errors.city_name && touched.city_name
                                ? "is-invalid"
                                : ""
                              }`}
                            placeholder="Enter City Name"
                            required
                          />
                          <ErrorMessage
                            name="city_name"
                            component="div"
                            className="text-danger"
                          />
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <Col md={12}>
                          <label htmlFor="state_name" className="form-label">State:</label>
                          <Field
                            as="select"
                            name="state_name"
                            className={`form-select ${errors.state_name && touched.state_name ? "is-invalid" : ""}`}
                          >
                            <option value="">Select State</option>
                            <option value="Andhra Pradesh">Andhra Pradesh</option>
                            <option value="Arunachal Pradesh">Arunachal Pradesh</option>
                            <option value="Assam">Assam</option>
                            <option value="Bihar">Bihar</option>
                            <option value="Chhattisgarh">Chhattisgarh</option>
                            <option value="Goa">Goa</option>
                            <option value="Gujarat">Gujarat</option>
                            <option value="Haryana">Haryana</option>
                            <option value="Himachal Pradesh">Himachal Pradesh</option>
                            <option value="Jharkhand">Jharkhand</option>
                            <option value="Karnataka">Karnataka</option>
                            <option value="Kerala">Kerala</option>
                            <option value="Madhya Pradesh">Madhya Pradesh</option>
                            <option value="Maharashtra">Maharashtra</option>
                            <option value="Manipur">Manipur</option>
                            <option value="Meghalaya">Meghalaya</option>
                            <option value="Mizoram">Mizoram</option>
                            <option value="Nagaland">Nagaland</option>
                            <option value="Odisha">Odisha</option>
                            <option value="Punjab">Punjab</option>
                            <option value="Rajasthan">Rajasthan</option>
                            <option value="Sikkim">Sikkim</option>
                            <option value="Tamil Nadu">Tamil Nadu</option>
                            <option value="Telangana">Telangana</option>
                            <option value="Tripura">Tripura</option>
                            <option value="Uttar Pradesh">Uttar Pradesh</option>
                            <option value="Uttarakhand">Uttarakhand</option>
                            <option value="West Bengal">West Bengal</option>
                          </Field>
                          <ErrorMessage name="state_name" component="div" className="text-danger" />
                        </Col>
                      </Row>

                      {/* Country (India, disabled) */}
                      <Row className="mb-3">
                        <Col md={12}>
                          <label htmlFor="country" className="form-label">Country:</label>
                          <Field
                            name="country"
                            type="text"
                            className="form-control"
                            disabled
                          />
                        </Col>
                      </Row>

                      {/* Pincode */}
                      <Row className="mb-3">
                        <Col md={12}>
                          <label htmlFor="pin_code" className="form-label">Pincode:</label>
                          <Field
                            name="pin_code"
                            type="text"
                            className={`form-control ${errors.pin_code && touched.pin_code ? "is-invalid" : ""}`}
                            placeholder="Enter Pincode"
                          />
                          <ErrorMessage name="pin_code" component="div" className="text-danger" />
                        </Col>
                      </Row>
                      <Row className="mt-4">
                        <Col className="text-center">
                          <Button type="submit" variant="success">
                            Add City
                          </Button>
                          <Button
                            variant="danger"
                            className="mx-2"
                            onClick={() => navigate("/citylist")}
                          >
                            Cancel
                          </Button>
                        </Col>
                      </Row>
                    </Form>
                  )}
                </Formik>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <ConfirmationModal
          show={showModal}
          onHide={handleCancel}
          modalMessage="Are you sure you want to add this city?"
          operationType={modalAction}
          confirmation={handleConfirm}
        />
        <NewconfirmationModal
          show={showSuccessModal}
          onHide={() => setShowSuccessModal(false)}
          modalMessage={successMessage}
          operationType="OK"
          timeoutDuration={3000}
        />
        <AllFailureModal
          show={showFailureModal}
          onHide={() => setShowFailureModal(false)}
          modalMessage={failureMessage}
          operationType="OK"
          timeoutDuration={3000}
        />
      </Container>
    );
  };

  export default CityAdd;
